require("../src/bootstrap")

import "../src/corporate.js";
import "../stylesheets/corporate.scss";
